import axios from 'axios'
import { API_TIMEOUT } from '../app_constant'

export const getMyConfig = (isOepnApi) => {
    var config = {}

    config.timeout = API_TIMEOUT
    config.headers = {}

    if (isOepnApi === false) {
        config.headers.token = 'SENDING_TOKEN'
    }
    let device_token = localStorage.getItem('fcmToken')

    if (device_token) {
        config.headers.devicetoken = device_token
    }

    return config
}

export const post = async (url, params, thunkAPI, isOepnApi = false) => {
    try {
        const response = await axios.post(url, params, getMyConfig(isOepnApi))
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue({ custom_error: error.message })
    }
}

export const multipart = async (url, params, thunkAPI, isOepnApi = false) => {
    try {

        const response = await axios.post(url, params, {
            ...getMyConfig({
                isOepnApi,
                isMultipart: true
            })
        })
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue({ custom_error: error.message })
    }
}

export const put = async (url, params, thunkAPI, isOepnApi = false) => {
    try {
        const response = await axios.put(url, params, getMyConfig(isOepnApi))
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue({ custom_error: error.message })
    }
}

export const get = async (url, thunkAPI, isOepnApi = false) => {
    try {
        const response = await axios.get(url, getMyConfig(isOepnApi))
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue({ custom_error: error.message })
    }
}